/* eslint-disable no-undef */
import config from './configuration';
import { load } from '../../packages/bootup';

load(config);
